export * from "./notary-generator";
